var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "emoji-c" },
    [
      _c("img", {
        staticClass: "triangle",
        attrs: { src: require("../../images/top-v.png") },
      }),
      _vm._v(" "),
      _c("EmojiList", {
        attrs: { articleId: _vm.articleId },
        on: { clickEmoji: _vm.handleEmoji },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }